import React from 'react';
import classNames from 'classnames';

import { connectWithRouter } from 'helpers/connectWithRouter';
import { bindActionCreators, Dispatch } from 'redux';
import * as _ from 'lodash-es';

import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import TextFieldWithClear from 'components/TextFieldWithIcon/TextFieldWithIcon';
import cx from 'classnames';
import { sendBookingTransactionEmail } from 'actions/Bookings/SendTransactionEmail';

const styles = require('./styles.pcss');

import { ReduxState } from '../../reducers/types';

type Props = {
  sendBookingTransactionEmail: Function;
  open: boolean;
  onClose: any;
  type: string;
  transactionId: any;
  amount: string;
  isLoading: any;
  travelersEmails: Array<string>;
};

type State = {
  additionalEmails: string;
  errorAdditionalEmails: any;
  waitingResponse: boolean;
};

class SendTransactionEmailPopup extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = this.getInitialState();
  }

  getInitialState() {
    return {
      additionalEmails: '',
      errorAdditionalEmails: false,
      waitingResponse: false,
    };
  }

  componentDidMount() {
    this.setState(this.getInitialState());
  }

  shouldComponentUpdate(nextProps: any) {
    if (this.props.isLoading == true && !_.get(nextProps, 'isLoading', true)) {
      this.onClose();
    }

    return true;
  }

  handleChangeEmails = (event: any) => {
    this.setState({
      additionalEmails: event.target.value,
      errorAdditionalEmails: false,
    });
  };

  onKeyUp = (e: any) => {
    if (e.keyCode === 13) {
      this.handleSubmit();
    }
  };

  onDeleteEmails = () => {
    this.setState({
      additionalEmails: '',
      errorAdditionalEmails: false,
    });
  };

  handleSubmit = () => {
    let errorEmail = false;

    let emails = this.state.additionalEmails
      .trim()
      .replace(/,\s*$/, '')
      .replace(/\s/g, '')
      .split(',');

    if (emails.length > 1) {
      _.forEach(emails, (email) => {
        if (!email.trim().match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
          errorEmail = true;
        }
      });
    }

    if (errorEmail == false) {
      const transactionId = this.props.transactionId;
      this.props.sendBookingTransactionEmail(transactionId, emails);
      this.props.onClose();

      this.setState({
        waitingResponse: true,
      });
    } else {
      this.setState({
        errorAdditionalEmails: 'Invalid Email Addresses',
      });
    }
  };

  onClose = () => {
    this.setState(this.getInitialState());
    this.props.onClose();
  };

  renderTravelersEmails = () => {
    return this.props.travelersEmails?.join(', ') || '';
  };

  render() {
    return (
      <Dialog
        fullWidth={true}
        maxWidth="md"
        className={cx(styles.dialogBox, styles.sendEmailConfirmation)}
        open={this.props.open}
        onClose={this.onClose}
      >
        <div className={classNames(styles.title)}>
          <div className={styles.titleStyle}>Send Transaction Receipt</div>
          <IconButton
            color="inherit"
            onClick={this.onClose}
            className={classNames(styles.closeIcon)}
            aria-label="Close"
            size="large"
          >
            <CloseIcon />
          </IconButton>
        </div>
        <div className={classNames(styles.content)}>
          <div className={classNames(styles.sendEmailText)}>
            A copy of the receipt for the transaction with amount{' '}
            {this.props.amount} will be sent to the following email addresses:
          </div>
          <div className={classNames(styles.additionalEmailsText)}>
            {this.renderTravelersEmails()}
          </div>
          <div className={classNames(styles.sendEmailText)}>
            To send to additional recipients, add their email addresses below.
          </div>
          <TextFieldWithClear
            fullWidth
            id="emailAddress"
            className={classNames(styles.textField)}
            label="Email address"
            variant="outlined"
            margin="normal"
            value={this.state.additionalEmails}
            onChange={this.handleChangeEmails}
            error={Boolean(this.state.errorAdditionalEmails)}
            helperText={this.state.errorAdditionalEmails}
            onKeyUp={this.onKeyUp}
            onClear={this.onDeleteEmails}
          />

          <div className={classNames(styles.actions, styles.actionsRight)}>
            <Button
              className={styles.button}
              variant="contained"
              color="primary"
              onClick={this.handleSubmit}
            >
              Send Receipt Email
            </Button>
          </div>
        </div>
      </Dialog>
    );
  }
}

function mapStateToProps(state: ReduxState) {
  return {
    isLoading: state.bookings.isLoading,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators(
    {
      sendBookingTransactionEmail,
    },
    dispatch,
  );
}

export default connectWithRouter(
  mapStateToProps,
  mapDispatchToProps,
)(SendTransactionEmailPopup);
